<template>
    <div class="col-12" v-if="mes != ''">
        <h4>Prefeitura Municipal de <b>{{ $store.state.settings.app_cidade }}</b></h4>
        <h4 v-if="unidade.length > 0">
           Unidade{{unidade.length > 1 ?'s' : ''  }}:   <span class="m-0" v-html="relatorio.unidades_nome"></span> <span class="m-0" v-html="unidades"></span> 
        </h4>
       
         <!-- <p class="m-0" v-for="item in dados.unidades" :key="item.id">
            <b>{{ item.nome }}</b> - {{ item.endereco }}
        </p> -->
        <h4>
            Relatório {{ periodo }} {{ relatorio.tipo?relatorio.tipo.toUpperCase():'' }} - <b> {{ periodo != "Anual" ? getMes(mes) : "" }} {{ ano }}</b>
        </h4>
    </div>
</template>
<script>
export default {
    props: ["periodo", "mes", "ano", "unidade", "dados","relatorio","unidades"],
    data() {
        return {
            meses: [
                { id: "01", value: "Janeiro" },
                { id: "02", value: "Fevereiro" },
                { id: "03", value: "Março" },
                { id: "04", value: "Abril" },
                { id: "05", value: "Maio" },
                { id: "06", value: "Junho" },
                { id: "07", value: "Julho" },
                { id: "08", value: "Agosto" },
                { id: "09", value: "Setembro" },
                { id: "10", value: "Outubro" },
                { id: "11", value: "Novembro" },
                { id: "12", value: "Dezembro" }
            ]
        };
    },
    methods: {
        getMes(mes) {
            const result = this.meses.filter(item => item.id == this.mes);
            return result[0] ? result[0].value : "";
        }
    }
};
</script>
